// Bootstrap
import Modal from "react-bootstrap/Modal";

const MainHeader = ({ dataTranslate, data, action }) => {
    return (
        <Modal.Header className="d-flex align-items-center justify-content-center ">
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
            >
                <span>
                    {action === "add"
                        ? dataTranslate.popups.customerShipment_tab.records.add_title
                        : action === "update"
                            ? dataTranslate.popups.customerShipment_tab.records.update_title
                            : ""}
                </span>
                {action === "update" ? (
                    <span style={{ color: "red" }}>{data.fullName}</span>
                ) : (
                    ""
                )}
            </Modal.Title>
        </Modal.Header>
    )
}

export default MainHeader;